import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';


import { Observable, throwError } from 'rxjs';

import { retry, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { EnumMasterType } from '../enum/MasterType';
import { KMATHierarchyDto } from '../models/KMATHierarchyDto';
import { KmatDto } from '../models/KmatDto';
import { TCConfigurationDataRequest } from '../models/tc-configuration';
import { CreateManualVBLODTO } from '../models/CreateManualVBLODTO';
import { TCConfigurationDetailDTO } from '../models/TCConfigurationDetailDTO';
import { ConfigImpacted } from '../models/ConfigImpacted';
import { MaterialRequestDTOForManualVBLO } from '../models/material-request-dtofor-manual-vblo';
import { MaterialDTOForManualVBLO } from '../models/material-dtofor-manual-vblo';
import { tcAuthorizationAccess } from '../models/tcAuthorizationAccess';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  // contains base Url
  readonly baseUrl = environment.baseURL

  private urlGetVBLOData = this.baseUrl + "api/TCConfiguration/GetKMATHierarchyWithVBLOs?projectId=";
  private urlGetKMATData = this.baseUrl + "api/TCConfiguration/GetAllKMAT?projectId=";
  private urlGetConfigurationData = this.baseUrl + "api/TCConfiguration/GetAllConfigurationForProject?projectId=";
  private urlPostConfigurationData = this.baseUrl + "api/TCConfiguration/InsertUpdateTCConfiguration";
  private urlDeleteConfiguration = this.baseUrl + "api/TCConfiguration/DeleteConfigurationById";
  private urlCopyConfiguration = this.baseUrl + "api/TCConfiguration/CopyConfigurationById"
  private urlLockUnlockConfiguration = this.baseUrl + "api/TCConfiguration/LockUnLockConfigurationById"
  private urlMvbloData = this.baseUrl + "api/TCConfiguration/CreateManualVBLO";
  private urlGetConfiguratiodeatils = this.baseUrl + "api/TCConfiguration/GetConfigurationDetails?configurationId=";
  private urlGetLinkKMATDetails = this.baseUrl + "api/TCConfiguration/GetLinkKMATDetails?configurationId=";
  private urlGetVBLOTypeAndAssemblyList = this.baseUrl + "api/TCConfiguration/GetVBLOTypeAndAssembly?businessAreaId=";
  private urlGetAllData = this.baseUrl + "api/TCConfiguration/GetImpactedProducts?projectId=";
  private urlGetAllMaterialByAssembly = this.baseUrl + "api/TCConfiguration/GetAllMaterialByAssembly";
  private urlGetAllConfigurationForAccess = this.baseUrl + "api/TCConfiguration/GetAllConfigurationForAccess?projectId=";
  private urlInsertUpdateTCAuthorizationAccess = this.baseUrl + "api/TCConfiguration/InsertUpdateTCAuthorizationAccess";
  private urlGetTCAuthorizationAccess = this.baseUrl + "api/TCConfiguration/GetTCAuthorizationAccess?projectId=";
  private urlPostForwardConfiguration = this.baseUrl + "api/TCConfiguration/ForwardConfigurationById";

  //lock/unlock configuration service methods
  private urlGetLockStatus = this.baseUrl + "api/TCConfiguration/LockConfigurationForEdit";
  private urlPostUnlockStatus = this.baseUrl + "api/TCConfiguration/UnlockConfigurationForEdit";
  constructor(private http: HttpClient) {
  }

  getConfigurationData(projectId, userId): Observable<any> {
    return this.http.get<any>(this.urlGetConfigurationData + projectId + "&userId=" + userId).pipe(
      retry(1),
      catchError(this.handleError)
    )
  }
  GetConfigurationDetails(configurationId): Observable<any> {
    return this.http.get<any>(this.urlGetConfiguratiodeatils + configurationId).pipe(
      retry(1),
      catchError(this.handleError)
    )
  }


  getVBLOData(projectId, configurationId, kmatId): Observable<KMATHierarchyDto> {
    return this.http.get<KMATHierarchyDto>(this.urlGetVBLOData + projectId + "&configurationId=" + configurationId + '&kmatId=' + kmatId).pipe(
      retry(1),
      catchError(this.handleError)
    )
  };

  getImpactedData(projectId, configurationId): Observable<ConfigImpacted> {
    return this.http.get<ConfigImpacted>(this.urlGetAllData + projectId + '&configurationId=' + configurationId).pipe(
      retry(1),
      catchError(this.handleError)
    )
  };


  getKmatData(projectId, configurationId): Observable<any> {
    return this.http.get(this.urlGetKMATData + projectId + "&configurationId=" + configurationId).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  saveConfiguration(tcConfigurationData: TCConfigurationDataRequest): Observable<any> {
    return this.http.post(this.urlPostConfigurationData, tcConfigurationData).pipe(
      retry(1),
      catchError(this.handleError)
    )
  }

  deleteConfiguration(obj): Observable<any> {
    let configurationId = obj.ConfigurationId;
    let userId = obj.UserId;
    return this.http.delete(this.urlDeleteConfiguration + "?configurationId=" + configurationId + "&userId=" + userId).pipe(
      retry(1),
      catchError(this.handleError)
    )
  }

  copyConfiguration(obj): Observable<any> {
    let configurationId = obj.ConfigurationId;
    let userId = obj.UserId;
    return this.http.post(this.urlCopyConfiguration + "?configurationId=" + configurationId + "&userId=" + userId, "").pipe(
      retry(1),
      catchError(this.handleError)
    )
  }

  lockUnlockConfiguration(obj): Observable<any> {
    let configurationId = obj.ConfigurationId;
    let userId = obj.UserId;
    return this.http.post(this.urlLockUnlockConfiguration + "?configurationId=" + configurationId + "&userId=" + userId, "").pipe(
      retry(1),
      catchError(this.handleError)
    )
  }

  postMVBLOData(data): Observable<CreateManualVBLODTO> {
    return this.http.post<CreateManualVBLODTO>(this.urlMvbloData, data).pipe(
      retry(1),
      catchError(this.handleError)
    );
  };

  InsertUpdateTCAuthorizationAccess(tcAuthorizationAccessData: tcAuthorizationAccess): Observable<any> {
    return this.http.post<any>(this.urlInsertUpdateTCAuthorizationAccess, tcAuthorizationAccessData).pipe(
      retry(1),
      catchError(this.handleError)
    )
  }
  // TypeScriptInsertUpdateTCAuthorizationAccess(data: tcAuthorizationAccess[]): Observable<any> {  return this.http.post<any>('your-api-endpoint', data);}
  GetLinkKMATDetails(configurationId): Observable<any> {
    return this.http.get(this.urlGetLinkKMATDetails + configurationId).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  GetVBLOTypeAndAssemblyList(businessAreaId, businessLineId): Observable<any> {
    return this.http.get(this.urlGetVBLOTypeAndAssemblyList + businessAreaId + "&businessLineId=" + businessLineId).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }


  getAllMaterialByAssembly(request: MaterialRequestDTOForManualVBLO): Observable<MaterialDTOForManualVBLO[]> {
    return this.http.post<MaterialDTOForManualVBLO[]>(this.urlGetAllMaterialByAssembly, request).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }
  GetAllConfigurationForAccess(projectId): Observable<any> {
    return this.http.get(this.urlGetAllConfigurationForAccess + projectId).pipe(
      retry(1),
      catchError(this.handleError)
    )
  };
  GetTCAuthorizationAccess(projectId, businessAreaId, businessLineId): Observable<any> {
    return this.http.get(this.urlGetTCAuthorizationAccess + projectId + "&businessAreaId=" + businessAreaId + "&businessLineId=" + businessLineId).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  GetLockStatus(projectId, configId, userId, isEditMode): Observable<any> {
    return this.http.post<any>(this.urlGetLockStatus + "?userId=" + userId + "&projectId=" + projectId + "&configurationId=" + configId + "&isEditMode=" + isEditMode, "").pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  UnLockConfiguration(projectId, configId, userId): Observable<any> {
    return this.http.post<any>(this.urlPostUnlockStatus + "?projectId=" + projectId + "&configurationId=" + configId + "&userId=" + userId, "").pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  
  // Synchronous unlock for tab close/beforeunload events
  UnLockConfigurationSync(projectId: number, configId: number, userId: number): void {
    const url = `${this.urlPostUnlockStatus}?projectId=${projectId}&configurationId=${configId}&userId=${userId}`;
    
    try {
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({}),
        keepalive: true
      });
    } catch (e) {
      console.error('Fetch keepalive failed:', e);
    }
  }

  ForwardConfiguration(configurationId: number, targetProjectId:number, userId: number): Observable<any> {
    return this.http.post<any>(this.urlPostForwardConfiguration + "?configurationId=" + configurationId + "&projectId=" + targetProjectId + "&userId=" + userId, "").pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  // It handle error ,server connection error and throws it to the component where its is recieved in the error of "subscribe" of service call method;
  handleError(error: HttpErrorResponse) {
    return throwError(error || "Server Error");
  }
}
